import {isNil} from 'ramda';

import {GetEmployeeMechanicsApiResponse} from '@dms/api/customer';

import {Nullish} from 'shared/web';

export const getOptionsFromMechanics = (mechanics: GetEmployeeMechanicsApiResponse | Nullish) => {
  if (isNil(mechanics) || mechanics.length === 0) {
    return [];
  }

  return mechanics.map((mechanic) => ({
    label: mechanic.name,
    value: mechanic.employeeId,
  }));
};
